import { useEffect, useState } from "react";
import { Input, Button } from "antd";
import { connect, useDispatch } from "react-redux";
import { Page, Note } from "../../../helbest";
import { _set_i_user } from "../../../store/actions/login_actions";
import { showAllErrors } from "../../../base/utils";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import { useAccountUpdateMutation } from "../../../saleor/api";
import { useTranslation } from "react-i18next";
import Loading from "../../components/Loading/Loading";
import { useLangNavigate } from "../../../hooks/useLangNavigate";

const ProfileEdit = (props) => {
  const navigate = useLangNavigate();
  const dispatch = useDispatch();
  const [firstName, setFirstName] = useState(props.Login.first_name);
  const [lastName, setLastName] = useState(props.Login.last_name);
  const { t, i18n } = useTranslation();
  const [accountUpdate, { loading }] = useAccountUpdateMutation({
    variables: {
      input: {
        firstName,
        lastName,
      },
    },
  });

  const check_user = () => {
    if (!props.Login.is_login) {
      navigate("/");
    }
  };

  useEffect(() => {
    check_user();
    // eslint-disable-next-line
  }, [props.Login.is_login]);

  const _Save = () => {
    if (!firstName && !lastName) {
      Note.error(t("profile.errors.first_name_and_last_name_required"));
    } else if (!firstName) {
      Note.error(t("profile.errors.first_name_required"));
    } else if (!lastName) {
      Note.error(t("profile.errors.last_name_required"));
    } else if (
      firstName === props.Login.first_name &&
      lastName === props.Login.last_name
    ) {
      Note.error(t("profile.errors.no_change"));
    } else {
      accountUpdate({
        onCompleted: (response) => {
          if (!response.accountUpdate.errors.length) {
            Note.success("Your account updated successfully");
            dispatch(
              _set_i_user({
                first_name: response.accountUpdate.user.firstName,
                last_name: response.accountUpdate.user.lastName,
                email: props.Login.email,
                phone_number: props.Login.phone_number,
              })
            );
          } else {
            showAllErrors(response.accountUpdate.errors);
          }
        },
      });
    }
  };

  return (
    <Page
      className="page-profile edit-profile-page"
      customHeader={<HeaderBack title={t("profile.edit")} />}
      back={true}
      address="/profile/"
      showFooter
      logo
    >
      <div className="flex flex-column">
        {loading ? (
          <div className="text-center mt-5">
            <Loading />
          </div>
        ) : null}

        <form
          className="profile-edit-form m-2"
          onSubmit={(e) => e.preventDefault()}
        >
          <label className="profile-edit-label">{t("common.first_name")}</label>
          <Input
            className={`profile-edit-select ${
              i18n.dir() === "rtl" ? "placeholder-align" : ""
            }`}
            type="text"
            dir="auto"
            value={firstName}
            disabled={loading}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder={t("profile.edit_page.first_name_placeholder")}
          />

          <label className="profile-edit-label">{t("common.last_name")}</label>
          <Input
            className={`profile-edit-select ${
              i18n.dir() === "rtl" ? "placeholder-align" : ""
            }`}
            type="text"
            dir="auto"
            value={lastName}
            disabled={loading}
            onChange={(e) => setLastName(e.target.value)}
            placeholder={t("profile.edit_page.last_name_placeholder")}
          />

          <div className="editProfileButton">
            <Button
              type="primary"
              style={{
                width: "100%",
                marginTop: "8px",
              }}
              loading={loading}
              onClick={() => _Save()}
            >
              {t("common.submit")}
            </Button>
          </div>
        </form>
      </div>
    </Page>
  );
};

const mstp = (state) => ({
  Login: state.Login,
});
export default connect(mstp)(ProfileEdit);
